import React from 'react';
import styled from 'styled-components';
import { Similarity } from '../../types';

export type Props = {
  // 類似クラスター番号、名前、クラスターについての説明などが格納されたオブジェクト
  similarity?: Similarity;
  // 類似エリアトップ3をリストで格納
  top3AreaName?: string[] | undefined;
};

const SimilarityDescription: React.FC<Props> = ({
  similarity,
  top3AreaName
}) => {
  return (
    <Wrapper>
      <SimilarityDescriptionLegend>
        <SimilarityDescriptionTitle>
          -この地域について-
        </SimilarityDescriptionTitle>
        <SimilarityDescriptionList>
          {similarity ? (
            <>
              <li>{similarity.similarAreaCategoryName}</li>
              <li>{similarity.similarAreaSummaryText}</li>
            </>
          ) : (
            <p>データがありません。</p>
          )}
          {top3AreaName && top3AreaName[0] !== '0' && (
            <>
              <SimilarityDescriptionTitle>
                -類似地域Top3-
              </SimilarityDescriptionTitle>
              <SimilarityDescriptionList>
                {top3AreaName.map((d, i) => (
                  <li key={i}>{d}</li>
                ))}
              </SimilarityDescriptionList>
            </>
          )}
        </SimilarityDescriptionList>
      </SimilarityDescriptionLegend>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 160px;
  position: absolute;
  bottom: 20px;
  left: 10px;
  padding: 8px;
  border-radius: 2px;
  background: #fff;
  color: #333;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  z-index: 800;
`;

const SimilarityDescriptionLegend = styled.div`
  text-align: left;
`;

const SimilarityDescriptionTitle = styled.p`
  text-align: center;
  font-weight: bold;
`;

const SimilarityDescriptionList = styled.div`
  list-style: inside;
`;

export default SimilarityDescription;
